"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const contact_sheet_model_1 = require("xchelper/models/contact-sheet.model");
class MailUtils {
    constructor(applicationConfiguration, $window, XucPhoneState, $translate) {
        this.applicationConfiguration = applicationConfiguration;
        this.$window = $window;
        this.XucPhoneState = XucPhoneState;
        this.$translate = $translate;
        this.replace = (text, pattern, value, fallback) => {
            let v = value ? value : fallback;
            let r = new RegExp(pattern, "g");
            return text.replace(r, v);
        };
        this.appConfig = this.applicationConfiguration.getCurrentAppConfig();
    }
    generateMeetingroomMailToLink(meetingroom) {
        var _a;
        const template = this.appConfig.mailInviteTemplate;
        const meetingroomName = meetingroom.name;
        const meetingroomLink = this.generateMeetingShareLink(meetingroom);
        const conferenceNumber = meetingroom.details && meetingroom.details[0] && meetingroom.details[0].fields && meetingroom.details[0].fields[0] ? meetingroom.details[0].fields[0].data : '';
        const calls = this.XucPhoneState.getCalls();
        const currentCallData = ((_a = calls === null || calls === void 0 ? void 0 : calls[0]) === null || _a === void 0 ? void 0 : _a.userData) ? calls[0].userData : {};
        const recipient = this.replaceMeetingroomVariables(template.recipient, meetingroomName, meetingroomLink, conferenceNumber, currentCallData);
        const subject = this.replaceMeetingroomVariables(template.subject, meetingroomName, meetingroomLink, conferenceNumber, currentCallData);
        const body = this.replaceMeetingroomVariables(template.body, meetingroomName, meetingroomLink, conferenceNumber, currentCallData);
        if (recipient)
            return encodeURI(`mailTo:?to=${recipient}&subject=${subject}&body=${body}`);
        else
            return encodeURI(`mailTo:?subject=${subject}&body=${body}`);
    }
    generateMeetingShareLink(contact) {
        let args = contact.actions[contact_sheet_model_1.ContactSheetActionEnum.ShareLink].args;
        return `${this.$window.location.origin}${args ? args[0] : ''}`;
    }
    generateMailToLink(contact, fieldEmail) {
        const template = this.appConfig.mailTemplate;
        const fullName = contact.name;
        const email = fieldEmail === undefined ? (contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail] && contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args && contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args[0] ? contact.actions[contact_sheet_model_1.ContactSheetActionEnum.Mail].args[0] : '') : fieldEmail;
        const calls = this.XucPhoneState.getCalls();
        const callerNum = lodash_1.default.get(calls.find((call) => call.otherDN !== 'anonymous'), 'otherDN');
        const subject = this.replaceVariables(template.subject, callerNum, fullName);
        const body = this.replaceVariables(template.body, callerNum, fullName);
        return encodeURI(`mailTo:${email}?subject=${subject}&body=${body}`);
    }
    replaceVariables(text, callerNum, fullName) {
        if (!text)
            return '';
        text = this.replace(text, '{callernum}', callerNum, 'PLACEHOLDER_NUMBER');
        text = this.replace(text, '{dstname}', fullName, 'PLACEHOLDER_NAME');
        return text;
    }
    replaceMeetingroomVariables(text, meetingroomName, meetingroomLink, conferenceNumber, attachedData) {
        if (!text)
            return '';
        text = this.replace(text, '{meetingroom_name}', meetingroomName, 'PLACEHOLDER_MEETINGROOM_NAME');
        text = this.replace(text, '{meetingroom_link}', meetingroomLink, 'PLACEHOLDER_MEETINGROOM_LINK');
        text = this.replace(text, '{meetingroom_number}', conferenceNumber, 'PLACEHOLDER_MEETINGROOM_NUMBER');
        for (const [key, value] of Object.entries(attachedData)) {
            text = this.replace(text, `{attached_data_${key.toLowerCase()}}`, value, '');
        }
        text = text.replace(/\{attached_data_[^}]*\}/g, '');
        return text;
    }
}
exports.default = MailUtils;
MailUtils.$inject = ["applicationConfiguration", "$window", "XucPhoneState", "$translate"];
